<template>
  <div class="app-container">
    <div class="topBack">
      <div class="back-btn" @click="goBack()">
        <i  style="font-size: 26px;
    color: #FFF;" class="el-icon-back"></i>
      </div>
      <div>
        <el-button v-if="roles.includes('/energy/send_bill')" type="primary" @click="sendBill()">发送账单</el-button>
        <el-button v-if="roles.includes('/energy/download_table')" type="primary" plain @click="derive()">下载能耗表</el-button>
        <el-button
        v-if="roles.includes('/energy/batch_bill_download')"
          @click="batchDownloadBill()"
          :disabled="multipleSelection.length == 0"
          type="primary"
          >批量下载账单</el-button
        >
      </div>
    </div>
    <div class="screenBox">
      <el-input
        class="screenInput"
        v-model="screen.room_number"
        placeholder="请输入房间号"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.company_name"
        placeholder="请输入公司名称"
      ></el-input>
      <el-button type="primary" @click="(screen.page = 1), getBill()"
        >筛选</el-button
      >
      <el-button type="primary" plain @click="chongZhi()">重置</el-button>
    </div>
    <div>
      <el-table
        max-height="630"
        v-loading="listLoading"
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
        :data="billList"
        element-loading-text="Loading"
        fit
        highlight-current-row
        stripe
        class="table-box"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        row-key="id"
        :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="房间号" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.room_number }}
          </template>
        </el-table-column>
        <el-table-column label="公司名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.company_name }}
          </template>
        </el-table-column>
        <el-table-column label="总计费用" align="center">
          <template slot-scope="scope">
            {{ scope.row.allocated_total_fee }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          label="操作"
          width="220"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="seeBill(scope.row)"
              v-if="roles.includes('/energy/bill_review_url')"
              >查看账单</el-button
            >
            <el-button
              size="mini"
              type="info"
              @click="downloadBill(scope.row.id, 'single')"
              v-if="roles.includes('/energy/bill_download')"
              >下载账单</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="screen.page"
        :page-sizes="[15, 30, 50]"
        :page-size="screen.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 10px"
      >
      </el-pagination>
    </div>
    <el-dialog :visible.sync="Browse" center>
      <div style="height: 600px; overflow: auto">
        <img style="margin: 0 auto" width="100%" :src="seeInfo.img" alt="" />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadBill(seeInfo.id, 'single')">
          下载账单
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import {send_bill, bill_review, bill_review_url, bill_download,download_table,batch_bill_download } from "@/api/energy";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl"]),
  },
  data() {
    return {
      listLoading: false,
      energyId: "",
      billList: [],
      total: 0,
      multipleSelection: [],
      screen: {
        page: 1,
        page_size: 15,
        room_number: "",
        company_name: "",
      },
      Browse: false,
      seeInfo: {},
    };
  },
  created() {
    this.energyId = this.$route.query.energyId;
    console.log("energyId", this.energyId);
    this.getBill();
  },
  mounted() {},
  methods: {
    // 发送账单
    sendBill() {
      let data = {
        id: this.energyId,
      };
      send_bill(data).then((res) => {
        if(res.code == 200){
          this.$message({
            message: "发送成功",
            type: "success",
          });
        }else{
          this.$message({
            message: "发送失败",
            type: "error",
          });
        }
      }).catch(error =>{
        this.$message({
          message: "发送失败",
          type: "error",
        });
      });
    },
    batchDownloadBill(){
      let ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
     let data = {
        id: ids.join(','),
      };
      const loading = this.$loading({
          lock: true,
          text: '数据量过大，正在导出中...',
          spinner: 'el-icon-loading'
        });
      batch_bill_download(data).then((res) => {
        loading.close();
        let blob = new Blob([res.data], {
          type: "application/zip" 
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = (res.name.match(/filename="([^"]+)"/) || [, 'images.zip'])[1];
        console.log("下载文件名:", res.name);
        // downloadElement.target="_blank"
        downloadElement.setAttribute("target", "_blank");
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(error =>{
        loading.close();
      });
    },
// 根据文件名获取 MIME 类型
 getFileType(filename) {
  const ext = filename.split('.').pop().toLowerCase();
  const typeMap = {
    'zip': 'application/zip',
    'pdf': 'application/pdf',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'xls': 'application/vnd.ms-excel',
    'doc': 'application/msword',
    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png'
  };
  return typeMap[ext] || 'application/octet-stream';
},

// 下载文件的通用函数
 downloadFile(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
},

    // 查看账单
    seeBill(row) {
      this.seeInfo = row;
      bill_review_url({ id: row.id }).then((res) => {
        // window.open(res.data.url);
        console.log(res);
        if (res.code == 200) {
          this.seeInfo.img = res.data.url;
          this.Browse = true;
        }
      });
    },
    // 单个下载
    downloadBill(id,type) {
      var that = this
      bill_download({ id: id }).then((res) => {
        var imgInfo = res.data.lists[0];
        that.downloadByBlob(imgInfo.image_url, imgInfo.company_name);
      });
    },
    downloadByBlob(imgsrc, name) {
    console.log(imgsrc, name)
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;

        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png");
        var a = document.createElement("a");
        // 创建一个单击事件
        var event = new MouseEvent("click");
        a.download = name;
        a.href = url;

        // 触发a的单击事件
        a.dispatchEvent(event);
      };
      image.src = imgsrc + '?tamp='+(new Date()).valueOf();
    },
    // 下载导出
    derive(id, type) {
      const loading = this.$loading({
        lock: true,
        text: "数据量过大，正在导出中...",
        spinner: "el-icon-loading",
      });
      // let ids = [];
      // if (type == "single") {
      //   ids.push(id);
      // } else {
      //   this.multipleSelection.forEach((item) => {
      //     ids.push(item.id);
      //   });
      // }
      download_table()
        .then((res) => {
          loading.close();
          let downloadElement = document.createElement("a");
          console.log(res.data)
          let href = res.data.url; //创建下载的链接
             const fileName = href.substring(href.lastIndexOf('/') + 1);
             console.log(fileName)
          downloadElement.href = href;
          downloadElement.download = fileName;
          // downloadElement.target="_blank"
          downloadElement.setAttribute("target", "_blank");
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((error) => {
          console.log(error);
          loading.close();
        });
    },
    chongZhi() {
      this.screen = {
        page: 1,
        page_size: 15,
        room_number: "",
        company_name: "",
      };
      this.getBill();
    },
    // 分页切换
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.getBill();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.getBill();
    },
    // 表格多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 返回
    goBack() {
      this.$router.push("/energy/index");
    },

    // 获取账单列表
    getBill() {
      let data = {
        energy_import_id: this.energyId,
        room_number: this.screen.room_number,
        company_name: this.screen.company_name,
        page: this.screen.page,
        page_size: this.screen.page_size,
      };
      this.listLoading = true
      bill_review(data).then((res) => {
        this.listLoading = false
        this.total = res.data.lists.total;
        this.billList = res.data.lists.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.w400 {
  width: 400px;
}
.topBack {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.back-btn{
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #66b1ff;
  display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.screenInput {
  width: 200px;
  margin-right: 10px;
  margin-bottom: 5px;
}

::v-deep .el-drawer__body {
  padding: 0 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.searchs {
  ::v-deep .el-form-item__label {
    opacity: 0 !important;
    display: block;
  }
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}

.tab-v {
  margin-top: 20px;
}

::v-deep .el-tabs__nav-next,
::v-deep .el-tabs__nav-prev {
  font-size: 20px;
}
.spaceDetail {
  padding: 40px;
  ::v-deep .el-input.is-disabled .el-input__inner {
    color: #606266;
  }
  ::v-deep .el-tag.el-tag--info {
    color: #606266;
    border-color: #606266;
  }
  ::v-deep .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
}
.house {
  padding-top: 20px;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
